import React, { Component } from 'react';
import IdleTimer from 'react-idle-timer'
import { IDLE_STATE_TIMEOUT } from './config/AppConfigurator';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoutes';
import { Layout } from './components/Layout';
import { Login } from './containers/Login/Login';
import { MeterDataEnquiryMethodSelection } from './containers/MeterDataEnquiryMethodSelection/MeterDataEnquiryMethodSelection';
import { MeterDataEnquiryPanel } from './containers/MeterDataEnquiryPanel/MeterDataEnquiryPanel';
import { QuerySelectionForMeterEnquiry } from './containers/QuerySelectionForMeterEnquiry/QuerySelectionForMeterEnquiry';
import { SessionModal } from './components/SessionModal/SessionModal';

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props)
    this.state = {
      modalValue: false,
    }
    this.idleTimer = null
    this.handleOnIdle = this.handleOnIdle.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  render() {    
    return (
      <Layout>
        <Routes>
          <Route index element={<Login />} />
          <Route path="query-selection-meter-enquiry" element={
            <ProtectedRoute pathname="query-selection-meter-enquiry">
              <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                timeout={ IDLE_STATE_TIMEOUT }
                onIdle={this.handleOnIdle}
                debounce={250}
              />  
              <QuerySelectionForMeterEnquiry/>
            </ProtectedRoute>} 
          />
          <Route path="meter-data-enquiry-method-selection" element={
            <ProtectedRoute pathname="meter-data-enquiry-method-selection">
              <IdleTimer
                ref={ref => { this.idleTimer = ref }}
                timeout={ IDLE_STATE_TIMEOUT }
                onIdle={this.handleOnIdle}
                debounce={250}
              /> 
              <MeterDataEnquiryMethodSelection/>
            </ProtectedRoute>} 
          />
          <Route path="meter-data-enquiry-panel" element={
          <ProtectedRoute pathname="meter-data-enquiry-method-selection">
            <IdleTimer
              ref={ref => { this.idleTimer = ref }}
              timeout={ IDLE_STATE_TIMEOUT }
              onIdle={this.handleOnIdle}
              debounce={250}
            /> 
            <MeterDataEnquiryPanel />
          </ProtectedRoute>} />
        </Routes>
        { this.state.modalValue &&
          <SessionModal modal={this.state.modalValue} toggle={this.toggleModal}/>
        }
      </Layout>
    );
  }

  toggleModal =()=> {
    this.setState({modalValue: !this.state.modalValue});
    window.location.replace('/');
  }

  handleOnIdle (event) {
    this.setState({modalValue: !this.state.modalValue})
  }
}
